<div class="successfulAccountCreation">
  <div class="row" *ngIf="!viewOptionMultiProduct">
    <div
      class="col-4 col-pr-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 offset-md offset-lg offset-xl-2"
    >
      <br />
      <div class="wrap" *ngIf="productSelected.product_type === 'livingPlace'">
        <h1 id="successful-title" class="title">
          {{ documentInfo.firstname }} {{ screenCopies.title }}
        </h1>
        <div class="box-desc">
          <div class="detail">
            <div *ngIf="resultPco == 'PCO03'" class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.caso_gz }}</p>
              <p>{{ caseNum }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.valor }}</p>
              <p class="money">${{ amountPco }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.plazo }}</p>
              <p>{{ mes }} meses</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.tasa }}</p>
              <p>{{ rateLiving }}</p>
              <p>{{ screenCopies.copy_tasa }}</p>
            </div>
            <div *ngIf="purchase" class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.compra }}</p>
              <p>{{ purchasePercent }} % del credito.</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.caso }}</p>
              <p>{{ caseNum }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.fecha }}</p>
              <p>{{ currentDate }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.ip }}</p>
              <span id="success-ip-text" class="span">{{ ipAddress }}</span>
            </div>
            <div *ngIf="resultPco == 'PCO01'" class="divider mt-3"></div>
            <div>
              <p *ngIf="resultPco == 'PCO01'">
                <span
                  ><strong>{{ screenCopies.continue }}</strong></span
                >
              </p>
              <p *ngIf="resultPco == 'PCO03'" class="content">
                {{ screenCopies.continue }}
              </p>
            </div>
          </div>
          <div *ngIf="resultPco == 'PCO01'" class="box-desc">
            <div id="steps">
              <ul class="mt-3">
                <vcl-list>
                  <li *ngFor="let option of options" vclListSimple>
                    <span id="iconCheck" class="icon icon-itaufonts_check">
                    </span>
                    <vcl-list-text class="list">
                      {{ option.value.replace('%s', amountPco) }}
                    </vcl-list-text>
                  </li>
                </vcl-list>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="wrap"
        *ngIf="
          productSelected.product_type !== 'livingPlace' &&
          productSelected.product_type !== 'loan'
        "
      >
        <div
          class="wrap"
          *ngIf="productSelected.code == '200' || productSelected.code == '201'"
        >
          <div class="image-container">
            <img
              id="successfulImg"
              alt="successful-account-creation"
              src="assets/images/success-process.svg"
            />
          </div>
          <h1
            id="successful-title"
            class="title"
            *ngIf="productSelected.code == '200'"
          >
            {{
              copyService.getParametrizedCopy(
                'successful_account_creation_title_savings',
                [documentInfo.firstname]
              )
            }}
          </h1>
          <h1
            id="successful-title"
            class="title"
            *ngIf="productSelected.code == '201'"
          >
            {{
              copyService.getParametrizedCopy(
                'successful_account_creation_title_nomina',
                [documentInfo.firstname]
              )
            }}
          </h1>

          <div class="content">
            <h2
              id="successful-subtitle"
              class="sub-title"
              *ngIf="productSelected.code == '200'"
            >
              {{
                copyService.copies.successful_account_creation_sub_title_savings
              }}
            </h2>
            <h2
              id="successful-subtitle"
              class="sub-title"
              *ngIf="productSelected.code == '201'"
            >
              {{
                copyService.copies.successful_account_creation_sub_title_nomina
              }}
            </h2>
            <div class="sub-content">
              <label id="success-number-label" class="label">{{
                copyService.copies
                  .successful_account_creation_account_number_label
              }}</label>
              <span id="success-number-text" class="span-account-number">{{
                accountNumber
              }}</span>
              <span id="success-number-label-2" class="label">{{
                copyService.copies
                  .successful_account_creation_sent_certificate_validation_text
              }}</span>
            </div>
            <div class="sub-content">
              <label id="success-date-label" class="label">{{
                copyService.copies
                  .successful_account_creation_date_and_time_label
              }}</label>
              <span id="success-date-text" class="span">{{ currentDate }}</span>

              <label id="success-ip-label" class="label">{{
                copyService.copies.successful_account_creation_ip_address
              }}</label>
              <span id="success-ip-text" class="span">{{ ipAddress }}</span>
            </div>
          </div>
          <!-- <div>
                        <h1 [innerHTML]="copyService.getParametrizedCopy('successful_account_creation_text_2_1', [maskedPhone])"></h1>
                    </div> -->
        </div>
        <div
          class="wrap"
          *ngIf="
            productSelected.code == '209' ||
            productSelected.code == '211' ||
            productSelected.code == '205' ||
            productSelected.code == '208' ||
            productSelected.code == '232'
          "
        >
          <h1
            id="successful-title"
            class="credit-title"
            *ngIf="
              productSelected.code == '209' &&
              (pcoStatus == 'PCO01' || firmlyApproved)
            "
          >
            {{
              productClient
                ? copyService.getParametrizedCopy(
                    'successful_account_creation_title_revolving_withAccount',
                    [documentInfo.firstname]
                  )
                : copyService.getParametrizedCopy(
                    'successful_account_creation_title_revolving',
                    [documentInfo.firstname]
                  )
            }}
          </h1>
          <h1
            id="successful-title"
            class="credit-title"
            *ngIf="
              productSelected.code == '211' &&
              (pcoStatus == 'PCO01' || firmlyApproved)
            "
          >
            {{
              productClient
                ? copyService.getParametrizedCopy(
                    'successful_account_creation_title_free_investment_withAccount',
                    [documentInfo.firstname]
                  )
                : copyService.getParametrizedCopy(
                    'successful_account_creation_title_free_investment',
                    [documentInfo.firstname]
                  )
            }}
          </h1>
          <h1
            id="successful-title"
            class="credit-title"
            *ngIf="pcoStatus == 'PCO03'"
          >
            {{
              copyService.getParametrizedCopy(
                'successful_account_creation_title_revolving_zng',
                [documentInfo.firstname]
              )
            }}
          </h1>

          <div class="content">
            <div class="sub-content">
              <div
                class="span-credit"
                *ngIf="
                  (productSelected.code == '209' ||
                    productSelected.code == '211') &&
                  (pcoStatus == 'PCO01' || firmlyApproved)
                "
              >
                <label id="success-date-label" class="credit-label">{{
                  copyService.copies
                    .successful_account_creation_account_numberCredit_label
                }}</label>
                <span id="success-date-text" class="span-credit-number">{{
                  detailRevolvingCredit.product_id
                }}</span>

                <label id="success-date-label" class="credit-label">{{
                  productClient
                    ? copyService.copies
                        .successful_account_creation_account_selected
                    : copyService.copies
                        .successful_account_creation_account_number_label
                }}</label>
                <span
                  id="success-date-text"
                  class="span-credit-number"
                  *ngIf="selectedAccount"
                >
                  {{
                    productSelected.code == '211'
                      ? selectedAccount.account_id
                      : accountNumber
                  }}
                </span>
                <span
                  id="success-date-text"
                  class="span-credit-number"
                  *ngIf="selectedAccountDetail"
                >
                  {{
                    productSelected.code == '211'
                      ? selectedAccountDetail.account_number
                      : accountNumber
                  }}
                </span>
              </div>

              <div class="span-credit" *ngIf="pcoStatus == 'PCO03'">
                <label id="success-date-label" class="credit-label">{{
                  copyService.copies
                    .successful_account_creation_account_numberCredit_label_zng
                }}</label>
                <span id="success-date-text" class="span-credit-number">{{
                  solicitationId
                }}</span>
              </div>

              <div
                class="span-credit"
                *ngIf="pcoStatus == 'PCO03' && productClient && !firmlyApproved"
              >
                <label id="success-date-label" class="credit-label">{{
                  copyService.copies
                    .successful_account_creation_account_selected
                }}</label>
                <span id="success-date-text" class="span-credit-number"
                  >{{ selectedAccount.account_type }}
                  {{
                    validationHelperService.maskPhone(
                      selectedAccount.account_id
                    )
                  }}</span
                >
              </div>

              <label id="success-date-label" class="credit-label">{{
                copyService.copies
                  .successful_account_creation_date_and_time_label2
              }}</label>
              <span id="success-date-text" class="span">{{ currentDate }}</span>

              <label id="success-ip-label" class="credit-label">{{
                copyService.copies.successful_account_creation_ip_address
              }}</label>
              <span id="success-ip-text" class="span text_ip">{{
                ipAddress
              }}</span>
            </div>
            <div class="extra-text" *ngIf="pcoStatus == 'PCO03'">
              <label>{{
                copyService.copies.successful_account_creation_extra_text_zng
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap" *ngIf="productSelected.product_type === 'loan'">
        <div class="wrap">
          <h1 id="successful-title" class="title">
            {{
              copyService.getParametrizedCopy(
                'succesful_account_creation_title_loan',
                [documentInfo.firstname]
              )
            }}
          </h1>
          <div class="detail">
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.valor }}</p>
              <p class="money">{{ amountPco }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.plazo }}</p>
              <p>{{ mes }} meses</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.tasa }}</p>
              <p>{{ rateLiving }}</p>
              <p>{{ screenCopies.copy_tasa }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.caso }}</p>
              <p>{{ caseNum }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.fecha }}</p>
              <p>{{ currentDate }}</p>
            </div>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{ screenCopies.ip }}</p>
              <span id="success-ip-text" class="span">{{ ipAddress }}</span>
            </div>
            <div class="divider mt-3"></div>
            <p>
              <span
                ><strong>{{ screenCopies.continue }}</strong></span
              >
              <li vclListSimple>
                <span id="iconCheck" class="icon icon-itaufonts_check"> </span>
                <vcl-list-text class="list">
                  {{ screenCopies.description_1 }}
                </vcl-list-text>
              </li>
              <li vclListSimple>
                <span id="iconCheck" class="icon icon-itaufonts_check"> </span>
                <vcl-list-text class="list">
                  {{
                    selectMethod == 'cheque'
                      ? screenCopies.description_3
                      : screenCopies.description_2
                  }}
                </vcl-list-text>
              </li>
            </p>
          </div>

          <app-controls
            id="successBtns"
            [hasPrevious]="false"
            [nextLabel]="screenCopies.button"
            (next)="next()"
          ></app-controls>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="viewOptionMultiProduct">
    <div
      class="col-4 col-pr-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 offset-md offset-lg offset-xl-2"
    >
      <div class="wrap">
        <h1 id="successful-title" class="title">
          {{ title }}
        </h1>
        <vcl-list>
          <li vclListSimple *ngIf="cardcredits.items.length > 0">
            <vcl-list-text>
              <h1
                *ngIf="cardcredits.title"
                id="successful-title"
                class="sub-title"
              >
                {{ getTitle(cardcredits.title) }}
              </h1>
              <div class="content">
                <label id="success-date-label" class="credit-label">{{
                  copyService.copies.detail_bonding_aprove_quota
                }}</label>
                <span id="success-date-text" class="span-credit-number">
                  ${{ cardcredits.cupo_total }}</span
                >
              </div>
              <h4 class="sub-title-3">
                {{ copyService.copies.detail_bonding_aprove_subtitle }}
              </h4>
              <div *ngIf="cardcredits.details">
                <vcl-list>
                  <li *ngFor="let detail of cardcredits.details" vclListSimple>
                    <em class="bullet icon-itaufonts_chat_enviado"></em>
                    <vcl-list-text>
                      <div class="titleTC">{{ detail }}</div>
                    </vcl-list-text>
                  </li>
                </vcl-list>
              </div>
              <div *ngIf="cardcredits.items" class="content">
                <label id="success-date-label" class="credit-label">{{
                  copyService.copies.detail_bonding_franchise
                }}</label>
              </div>
              <div class="container-cardPanel" *ngIf="!firmlyApproved">
                <div
                  [ngClass]="{
                    cardPanel: row.virtual,
                    'cardPanel-no-virtual': !row.virtual
                  }"
                  *ngFor="let row of cardcredits.items"
                >
                  <div class="cardDetails" *ngIf="row.virtual">
                    <div class="cardText">
                      <h3 class="cardName">
                        {{ row.brand }}
                        {{
                          copyService.copies
                            .successful_credit_card_valid_card_name_virtual
                        }}
                      </h3>
                      <p class="setCreditCard">
                        <span class="label">{{ row.product_id }} </span>
                        <span class="label label-uppercase"
                          >{{
                            documentInfo.firstname +
                              ' ' +
                              documentInfo.middlename +
                              ' ' +
                              documentInfo.primary_lastname +
                              ' ' +
                              documentInfo.second_lastname
                          }}
                        </span>
                      </p>
                    </div>
                    <div class="cardImages">
                      <img
                        id="itauImages"
                        class="image"
                        src="assets/images/itau_rectangle.svg"
                        alt="Itaú"
                      />
                      <img
                        id="visaCreditCard"
                        class="image"
                        src="assets/images/icon-card.svg"
                        alt="Visa"
                        *ngIf="!row.brand.includes('Master')"
                      />
                      <img
                        id="visaCreditCard"
                        class="image"
                        src="assets/images/Mastercard_preto.svg"
                        alt="MasterCard"
                        *ngIf="row.brand.includes('Master')"
                      />
                    </div>
                  </div>
                  <div class="cardDetails" *ngIf="!row.virtual">
                    <div class="icon" _icon-credit-card>
                      <em class="icon-itaufonts_cartao"></em>
                    </div>
                    <h3 class="label-copy">{{ row.brand }}</h3>
                  </div>
                  <div class="dateAndAmount" *ngIf="row.virtual">
                    <p id="validThru" class="setCreditCard">
                      <span class="label">{{
                        copyService.copies
                          .successful_credit_card_valid_thru_text
                      }}</span>
                      <span class="description">{{ row.expiration_date }}</span>
                    </p>
                    <p id="amount" class="setCreditCard">
                      <span class="label">{{
                        copyService.getParametrizedCopy(
                          'successful_credit_card_creation_credit_card_amount',
                          [row.available_amount.amount]
                        )
                      }}</span>
                      <span class="description">{{
                        copyService.copies.successful_credit_card_valid_amount
                      }}</span>
                    </p>
                  </div>
                  <div class="dateAndAmount" *ngIf="!row.virtual">
                    <p class="setCreditCard">
                      <span class="label-text">{{
                        copyService.copies.successful_credit_card_valid_amount
                      }}</span>
                      <span class="text">{{
                        copyService.getParametrizedCopy(
                          'successful_credit_card_creation_credit_card_amount',
                          [row.available_amount.amount]
                        )
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="container-cardPanel" *ngIf="firmlyApproved">
                <div class="cardPanel" *ngFor="let row of cardcredits.items">
                  <div class="cardDetails">
                    <div class="cardText">
                      <h3 class="cardName">
                        {{ row.brand }}
                        {{
                          row.virtual
                            ? copyService.copies
                                .successful_credit_card_valid_card_name_virtual
                            : ''
                        }}
                      </h3>
                      <p class="setCreditCard">
                        <span class="label">{{ row.product_id }} </span>
                        <span class="label label-uppercase"
                          >{{
                            documentInfo.firstname +
                              ' ' +
                              documentInfo.middlename +
                              ' ' +
                              documentInfo.primary_lastname +
                              ' ' +
                              documentInfo.second_lastname
                          }}
                        </span>
                      </p>
                    </div>
                    <div class="cardImages">
                      <img
                        id="itauImages"
                        class="image"
                        src="assets/images/itau_rectangle.svg"
                        alt="Itaú"
                      />
                      <img
                        id="visaCreditCard"
                        class="image"
                        src="assets/images/icon-card.svg"
                        alt="Visa"
                        *ngIf="!row.brand.includes('Master')"
                      />
                      <img
                        id="visaCreditCard"
                        class="image"
                        src="assets/images/Mastercard_preto.svg"
                        alt="MasterCard"
                        *ngIf="row.brand.includes('Master')"
                      />
                    </div>
                  </div>
                  <div class="dateAndAmount">
                    <p id="validThru" class="setCreditCard">
                      <span class="label">{{
                        copyService.copies
                          .successful_credit_card_valid_thru_text
                      }}</span>
                      <span class="description">{{ row.expiration_date }}</span>
                    </p>
                    <p id="amount" class="setCreditCard">
                      <span class="label">{{
                        copyService.getParametrizedCopy(
                          'successful_credit_card_creation_credit_card_amount',
                          [row.available_amount.amount]
                        )
                      }}</span>
                      <span class="description">{{
                        copyService.copies.successful_credit_card_valid_amount
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="infoBox">
                <div class="creditCardInfo">
                  <span id="creditCardInfoText" class="creditCardInfoText">{{
                    copyService.copies.successful_credit_card_creation_info
                  }}</span>
                </div>
                <div class="creditCardLink">
                  <p id="link" class="link">
                    {{
                      copyService.copies
                        .successful_credit_card_creation_info_itau
                    }}
                    <vcl-link
                      (click)="openLink()"
                      [label]="
                        copyService.copies.invitation_register_step_three_link
                      "
                      class="termsLink"
                      [linkId]="'alliances'"
                    >
                    </vcl-link>
                  </p>
                  <span id="moreInfo" class="creditCardInfoText">{{
                    copyService.copies
                      .successful_credit_card_creation_info_itau_description
                  }}</span>
                </div>
              </div>
            </vcl-list-text>
          </li>
          <li vclListSimple *ngIf="credits.length > 0">
            <vcl-list-text>
              <h1 class="sub-title">
                {{
                  copyService.copies.successful_account_creation_title_credits
                }}
              </h1>
              <div *ngFor="let row of credits">
                <div class="content">
                  <label id="success-date-label" class="credit-label">{{
                    getTitle(row.product_type)
                  }}</label>
                  <span id="success-date-text" class="span-credit-number">{{
                    row.product_id
                  }}</span>
                </div>
              </div>
            </vcl-list-text>
          </li>
          <li vclListSimple *ngIf="accounts.length > 0">
            <vcl-list-text>
              <div *ngFor="let row of accounts">
                <div class="content">
                  <h1 class="sub-title">{{ getTitle(row.product_type) }}</h1>
                  <label id="success-date-label" class="credit-label">{{
                    copyService.copies
                      .successful_account_creation_account_number
                  }}</label>
                  <span id="success-date-text" class="span-credit-number">{{
                    row.product_id
                  }}</span>
                  <label id="success-date-label" class="credit-label">{{
                    copyService.copies
                      .successful_account_creation_date_and_time_label2
                  }}</label>
                  <span id="success-date-text" class="span">{{
                    currentDate
                  }}</span>
                  <label id="success-ip-label" class="credit-label">{{
                    copyService.copies.successful_account_creation_ip_address
                  }}</label>
                  <span id="success-ip-text" class="span text_ip">{{
                    ipAddress
                  }}</span>
                </div>
              </div>
            </vcl-list-text>
          </li>
        </vcl-list>
        <br />
      </div>
    </div>
  </div>
</div>
<div
  [ngClass]="{ 'aditional-info': !productClient }"
  *ngIf="
    productSelected.code == '209' ||
    productSelected.code == '211' ||
    productSelected.code == '205' ||
    productSelected.code == '208' ||
    productSelected.code == '232'
  "
>
  <!-- <div class="content" *ngIf="!productClient">
        <em class="icon icon-itaufonts_telefone" id="icon"></em>
        <p class="bottom-text" id="textFooter">
            {{ copyService.copies.successful_account_creation_extra_text1 }}
            {{maskedPhone}}, {{ copyService.copies.successful_account_creation_extra_text2 }}
        </p>
    </div> -->
  <app-controls
    id="successBtns"
    [hasPrevious]="false"
    [nextLabel]="copyService.copies.successful_account_creation_button_label_ok"
    (next)="next()"
  ></app-controls>
</div>

<div *ngIf="productSelected.code == '200' || productSelected.code == '201'">
  <p class="bottom-text" id="textFooter">
    {{ copyService.copies.successful_account_creation_extra_text1 }}
    <span>{{ maskedPhone }}</span
    >, {{ copyService.copies.successful_account_creation_text_2_2 }}
  </p>
  <app-controls
    id="successBtns"
    [hasPrevious]="false"
    [nextLabel]="copyService.copies.successful_account_creation_button_label"
    (next)="next()"
  ></app-controls>
</div>
<app-controls
  *ngIf="productSelected.product_type == 'livingPlace'"
  id="successBtns"
  [hasPrevious]="false"
  [nextLabel]="screenCopies.button"
  (next)="next()"
></app-controls>
